import {
  FETCH_SHIFTS, FETCH_SHIFTS_SUCCESS, FETCH_SHIFTS_FAILURE,
  CREATE_SHIFT, CREATE_SHIFT_SUCCESS, CREATE_SHIFT_FAILURE,
  UPDATE_SHIFT, UPDATE_SHIFT_SUCCESS, UPDATE_SHIFT_FAILURE,
  DELETE_SHIFT, DELETE_SHIFT_SUCCESS, DELETE_SHIFT_FAILURE
} from "./actionTypes";

// Fetch Shifts
export const fetchShifts = (unitId) => ({ type: FETCH_SHIFTS, payload: { unitId } });
export const fetchShiftsSuccess = (shifts) => ({ type: FETCH_SHIFTS_SUCCESS, payload: shifts });
export const fetchShiftsFailure = (error) => ({ type: FETCH_SHIFTS_FAILURE, payload: error });

// Create Shift
export const createShift = (formData) => ({ type: CREATE_SHIFT, payload: {formData} });
export const createShiftSuccess = (shift) => ({ type: CREATE_SHIFT_SUCCESS, payload: shift });
export const createShiftFailure = (error) => ({ type: CREATE_SHIFT_FAILURE, payload: error });

// Update Shift
export const updateShift = (shift) => ({ type: UPDATE_SHIFT, payload: shift });
export const updateShiftSuccess = (shift) => ({ type: UPDATE_SHIFT_SUCCESS, payload: shift });
export const updateShiftFailure = (error) => ({ type: UPDATE_SHIFT_FAILURE, payload: error });

// Delete Shift
export const deleteShift = (id) => ({ type: DELETE_SHIFT, payload: id });
export const deleteShiftSuccess = (id) => ({ type: DELETE_SHIFT_SUCCESS, payload: id });
export const deleteShiftFailure = (error) => ({ type: DELETE_SHIFT_FAILURE, payload: error });
